import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MenuComponent } from 'ngx-editor';
import { ConfirmModalComponent } from '../../../../shared/components/confirm-modal/confirm-modal.component';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { OrigemDocumentoFiscalRecebidoEnum } from '../../../../shared/enums/repo-dfe/origem-documento-fiscal-recebido.enum';
import { TipoEventoNFeEnum } from '../../../../shared/enums/dfe/tipo-evento-nfe.enum';
import { StatusDocumentoEnum } from '../../../../shared/enums/dfe/status-documento.enum';
import { DisponibilidadeDocumentoSefazEnum } from '../../../../shared/enums/dfe/disponibilidade-documento-sefaz.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { PostManifestacaoService } from '../../../../shared/services/apis/orquestrador-dfe/post-manifestacao.service';
import { PostManifestacaoRequest } from '../../../../shared/services/requests/orquestrador-dfe/post-manifestacao.request';
import { ProdutoDocumentoFiscalStruct } from '../../../../shared/services/structs/repo-dfe/produto-documento-fiscal.struct';
import { DetalheNFeRecebidoResponse } from '../../../../shared/services/responses/repo-dfe/detalhe-nfe-recebido.response';
import { ModeloDocumentoEnum } from '../../../../shared/enums/dfe/modelo-documento.enum';
import { ReturnStruct } from '../../../../shared/services/structs/return.struct';
import {
    EVENTOS_MANIFESTACAO_CONCLUSIVA_NFE,
    EVENTOS_MANIFESTACAO_NFE,
    isManifestacaoBloqueada,
    TAMANHO_MINIMO_JUSTIFICATIVA_MANIFESTACAO,
} from '../../../../shared/helpers/manifestacao-nfe.helper';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@Component({
    selector: 'app-nfe-detalhe',
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatTooltipModule,
        CurrencyPipe,
        DatePipe,
        LoadingBoxComponent,
        MatMenuModule,
        MatDialogModule,
        NgxMaskPipe
    ],
    providers: [provideNgxMask()],
    templateUrl: './nfe-detalhe.component.html',
    styleUrls: ['./nfe-detalhe.component.css']
})
export class NFeDetalheComponent implements OnInit {
    @Input() notaDetalhe!: DetalheNFeRecebidoResponse;
    @Input() idDFeRecebido: number | null = null;
    @Input() origemDocumentoFiscalRecebido: OrigemDocumentoFiscalRecebidoEnum = OrigemDocumentoFiscalRecebidoEnum.EstruturaAntiga;
    @Output() refreshData = new EventEmitter<void>();

    public readonly cfopMaskPatterns = { '0': { pattern: /[0-9?]/ } };

    public _isLoading = true;
    public _isLoadingInitialData = true;
    public idEmpresa: number | null = null;

    public displayedColumnsProdutos: string[] = ['numero', 'codigo', 'descricao', 'valorTotal', 'cfop', 'gtin', 'ncm'];
    public dataSourceProdutos = new MatTableDataSource<ProdutoDocumentoFiscalStruct>();
    public _isCancelamento: boolean = false;

    //Para manifestação
    public _tipoEventoNFeEnum = TipoEventoNFeEnum;
    public readonly eventosManifestacaoConclusiva = EVENTOS_MANIFESTACAO_CONCLUSIVA_NFE;
    public _manifestacaoEmAndamento = false;
    public _idTipoEventoManifestacao: number | null = null;
    public _isManifestacaoConclusivaNaoIdentificada = false;

    constructor(
        private alertService: AlertService,
        private postManifestacaoService: PostManifestacaoService,
        private router: Router,
        private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.idEmpresa = this.notaDetalhe.idEmpresa;
        this.dataSourceProdutos.data = this.notaDetalhe.produtos;
        this._isCancelamento = this.notaDetalhe.resumo.idStatusDocumento === StatusDocumentoEnum.Cancelado;
        this._idTipoEventoManifestacao = this.notaDetalhe.resumo.idTipoEventoManifestacaoAtual;
        this._isManifestacaoConclusivaNaoIdentificada = this.notaDetalhe.resumo.isManifestacaoConclusivaNaoIdentificada;
        this._isLoading = false;
    }

    voltar() {

        this.router.navigate(['/notas-fiscais/notas-recebidas/']);
    }

    public isManifestacaoDisabled(): boolean {
        return isManifestacaoBloqueada(this._isCancelamento, this._idTipoEventoManifestacao);
    }

    public obterDescricaoSituacaoDocumento(): string {
        if (!this.notaDetalhe) return '';
        if (this.notaDetalhe.resumo.idStatusDocumento === StatusDocumentoEnum.Cancelado) return 'Cancelado';

        switch (this.notaDetalhe.resumo.idTipoEventoManifestacaoAtual) {
            case TipoEventoNFeEnum.ConfirmacaoOperacao: return 'Confirmação da Operação';
            case TipoEventoNFeEnum.CienciaEmissao: return 'Ciência da Emissão';
            case TipoEventoNFeEnum.DesconhecimentoOperacao: return 'Desconhecimento da Operação';
            case TipoEventoNFeEnum.OperacaoNaoRealizada: return 'Operação Não Realizada';
        }

        if (this.notaDetalhe.resumo.isManifestacaoConclusivaNaoIdentificada)
            return 'Manifestação conclusiva; tipo não identificado no histórico';

        if (this.notaDetalhe.resumo.descricaoSituacaoDocumento)
            return this.notaDetalhe.resumo.descricaoSituacaoDocumento;

        switch (this.notaDetalhe.resumo.idDisponibilidadeDocumentoSefaz) {
            case DisponibilidadeDocumentoSefazEnum.DocumentoCompleto: return 'Documento completo';
            case DisponibilidadeDocumentoSefazEnum.ResumoRecebido: return 'Resumo recebido';
            case DisponibilidadeDocumentoSefazEnum.Identificado: return 'Identificado';
            default: return this.notaDetalhe.resumo.idStatusDocumento === StatusDocumentoEnum.Autorizado ? 'Autorizado' : 'Situação não identificada';
        }
    }

    public isCienciaDisabled(): boolean {
        if (!this.notaDetalhe) return true;

        return !this.isDocumentoResumido
            || this._idTipoEventoManifestacao !== null
            || this._isManifestacaoConclusivaNaoIdentificada;
    }

    public get isDocumentoResumido(): boolean {
        return this.notaDetalhe.isDocumentoResumido;
    }

    public cienciaTooltip(): string {
        if (this.isCienciaDisabled()) {
            if (!this.isDocumentoResumido) {
                return 'Ciência da Operação só está disponível para notas resumidas.';
            }
            if (this._isManifestacaoConclusivaNaoIdentificada) {
                return 'Uma manifestação conclusiva já foi registrada, mas o tipo não foi identificado no histórico.';
            }
            if (this._idTipoEventoManifestacao !== null) {
                return EVENTOS_MANIFESTACAO_NFE
                    .find(x => x.idTipoEvento === TipoEventoNFeEnum.CienciaEmissao)!.motivoJaRegistrado;
            }
        }
        return '';
    }

    public abrirModalConfirmacao(tipoEventoId: TipoEventoNFeEnum): void {

        // 1. Textos e exigência de justificativa vêm da regra compartilhada com a Central de NFs de entrada
        const evento = EVENTOS_MANIFESTACAO_NFE.find(x => x.idTipoEvento === tipoEventoId)!;

        // 2. Adiciona a chave da nota ao conteúdo HTML
        const modalHtmlContent = `<p>${evento.descricao}</p>`
            + `<br><p style="font-size: 0.9em; color: #6c757d; word-break: break-all;"><strong>Chave:</strong><br>${this.notaDetalhe?.informacoesDocumento.chave || 'Chave não encontrada'}</p>`;

        // 3. Monta o objeto 'data' para o ConfirmModalComponent
        const dialogData = {
            title: evento.titulo,
            innerHtml: modalHtmlContent, // Passa o HTML para o modal
            description: null, // Deixa nulo para não ativar o <p>{{_description}}</p>
            buttonConfirm: 'Confirmar',
            buttonClose: 'Cancelar',

            // Passa os dados para o textarea opcional
            showTextarea: evento.isJustificativaObrigatoria,
            textareaLabel: evento.isJustificativaObrigatoria
                ? `Justificativa (mínimo ${TAMANHO_MINIMO_JUSTIFICATIVA_MANIFESTACAO} caracteres)`
                : '',
            textareaRequired: evento.isJustificativaObrigatoria,
            textareaMinLength: TAMANHO_MINIMO_JUSTIFICATIVA_MANIFESTACAO
        };

        // 4. Abre o modal genérico
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            width: '500px',
            data: dialogData
        });

        // 5. Trata o retorno (o seu modal genérico retorna um objeto diferente)
        dialogRef.afterClosed().subscribe(result => {
            // 'result' agora é: { confirm: boolean, textareaValue: string | null }

            if (result && result.confirm) {
                // Passa o 'result.textareaValue' como a justificativa
                this.executarManifestacao(tipoEventoId, result.textareaValue);
            }
        });
    }

    private executarManifestacao(tipoEventoId: TipoEventoNFeEnum, justificativa: string | null): void {
        if (!this.idDFeRecebido || !this.idEmpresa) {
            this.alertService.show('Aviso manifestação!', 'Empresa do documento não encontrada.', AlertType.warning);
            return;
        }

        const request: PostManifestacaoRequest = {
            idDFeRecebido: this.idDFeRecebido,
            idEmpresaAlvo: this.idEmpresa,
            idModeloDocumento: ModeloDocumentoEnum.NFe,
            idTipoEvento: tipoEventoId,
            origemDocumentoFiscalRecebido: this.origemDocumentoFiscalRecebido,
            justificativa: justificativa
        };

        this._manifestacaoEmAndamento = true;
        this.postManifestacaoService.postManifestacao(request).subscribe({
            next: (response: ReturnStruct) => {
                if (response.isError) {
                    this.alertService.show('Aviso manifestação!', response.errorDescription, AlertType.warning);
                    this._manifestacaoEmAndamento = false;
                    return;
                }

                this.alertService.show('Sucesso', 'Manifestação realizada com sucesso!', AlertType.success);
                this.refreshData.emit();
                this._manifestacaoEmAndamento = false;
            },
            error: (error) => {
                this.alertService.show('Erro inesperado', error.message, AlertType.error);
                this._manifestacaoEmAndamento = false;
            }
        });
    }
}
